(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || window.VivereMoneyFormat || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  window.VivereFormatMoney = formatMoney;

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = root.querySelector('[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var current = product.variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || product.variants[0];

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts[Number(fs.getAttribute('data-option-index'))] = checked ? checked.value : null;
      });
      return opts;
    }

    function qty() {
      var o = root.querySelector('input[name="vl-offer-' + root.dataset.section + '"]:checked');
      return o ? Number(o.getAttribute('data-qty')) || 1 : 1;
    }

    function render() {
      var q = qty();
      if (qtyInput) qtyInput.value = q;
      if (!current) {
        root.querySelectorAll('[data-atc]').forEach(function (b) { b.disabled = true; b.querySelector('[data-atc-label]').textContent = root.dataset.unavailable || 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = current.id;
      var total = formatMoney(current.price * q);
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = total; });
      root.querySelectorAll('[data-compare]').forEach(function (el) {
        if (current.compare_at_price && current.compare_at_price > current.price) { el.textContent = formatMoney(current.compare_at_price * q); el.hidden = false; }
        else { el.hidden = true; }
      });
      root.querySelectorAll('[data-offer-price]').forEach(function (el) {
        el.textContent = formatMoney(current.price * Number(el.getAttribute('data-offer-price')));
      });
      var packFs = root.querySelector('[data-pack-index]');
      if (packFs) {
        var pi = Number(packFs.getAttribute('data-pack-index'));
        var findPack = function (value) {
          return product.variants.find(function (v) {
            return v.options.every(function (o, i) { return i === pi ? o === value : o === current.options[i]; });
          });
        };
        var values = Array.prototype.map.call(packFs.querySelectorAll('input[type="radio"]'), function (r) { return r.value; });
        var unit = findPack(values[0]);
        root.querySelectorAll('[data-offer-value]').forEach(function (el) {
          var v = findPack(el.getAttribute('data-offer-value'));
          el.textContent = v ? formatMoney(v.price) : '';
        });
        root.querySelectorAll('[data-offer-save]').forEach(function (el) {
          var value = el.getAttribute('data-offer-save');
          var v = findPack(value);
          var n = parseInt(value, 10) || (values.indexOf(value) + 1);
          if (!v || !unit || n < 2) { el.hidden = true; return; }
          var full = unit.price * n;
          var pct = Math.round((1 - v.price / full) * 100);
          if (pct > 0) { el.textContent = 'Save ' + pct + '%'; el.hidden = false; } else { el.hidden = true; }
        });
      }
      root.querySelectorAll('[data-atc]').forEach(function (b) {
        b.disabled = !current.available;
        var label = b.querySelector('[data-atc-label]');
        if (label) label.textContent = current.available ? (b.getAttribute('data-label') || 'Add to cart') : (root.dataset.soldout || 'Sold out');
      });
      root.querySelectorAll('[data-option-value]').forEach(function (el) {
        var i = Number(el.getAttribute('data-option-value'));
        el.textContent = current.options[i];
      });
      if (current.featured_media && current.featured_media.id) showMedia(String(current.featured_media.id));
    }

    function showMedia(id) {
      var main = root.querySelector('[data-main-media]');
      var thumb = root.querySelector('[data-thumb="' + id + '"]');
      if (!main || !thumb) return;
      var img = main.querySelector('img');
      if (img) {
        img.src = thumb.getAttribute('data-src');
        img.srcset = thumb.getAttribute('data-srcset') || '';
        img.alt = thumb.getAttribute('data-alt') || '';
      }
      root.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) {
        var opts = selectedOptions();
        current = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] == null || opts[i] === o; });
        }) || null;
        if (current && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
        }
        render();
      }
      if (e.target.name && e.target.name.indexOf('vl-offer-') === 0) render();
    });

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) showMedia(t.getAttribute('data-thumb'));
    });

    render();
  }

  function initCart() {
    document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () { input.form.submit(); });
    });
    document.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        var v = Math.max(0, Number(input.value) + Number(btn.getAttribute('data-qty-step')));
        input.value = v;
        input.form.submit();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initCart();
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-product-section]');
    if (root) initProduct(root);
  });
})();
